import { API_URL } from "../constants/constants"

export const getUserNfts = async (sessionToken) => {
  try {
    const response = await fetch(`${API_URL}/user/nfts`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionToken ? `Bearer ${sessionToken}` : "",
      },
      body: JSON.stringify({}),
    })

    return await response.json()
  } catch (error) {
    return {
      success: false,
      error: error.message,
    }
  }
}
